import { useMutation, useQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import useProcessData, { convertToAge } from "../../../CommonFunction/ProcessData";
import { LoadTable, Loading } from "../../Components";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import { RenderData } from "./DisplayInfo";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import { Confirm } from "../../Components/Confirmation/Confirm";

export const MatchingModal = ({ TypeofPortal, show, Id, setShowModal, query, dataKey, dataById, Edit }) => {
  const [formData, setFormData] = useState([]);
  const [DisplayData, setDisplayData] = useState<any>()
  const [confirmModal, setConfirmModal] = useState(false)
  const [editId, setEditId] = useState("")
  const [CloseEntry, { loading: EditLoading }] = useMutation(Edit, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  })
  const { data, error, loading, refetch } = useQuery(query, {
    variables: {
      searchId: Id,
    },
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const { data: Data } = useQuery(dataById, {
    variables: {
      id: Id,
    },
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  useEffect(() => {
    console.log(TypeofPortal)
    if (Data && Object.values(Data)[0]) {
      if (TypeofPortal.includes("Truck")) {
        console.log(Data)
        let dataObject: any = Data["loadByID"][0]

        console.log(dataObject)
        let obj = {
          Business_Name: dataObject?.AccountData?.Business_Name,
          Load_Live_Duration: dataObject?.Load_Live_Duration,
          Vehicle: dataObject?.VehicleCategoryGroupData?.map((item: any) => (`${item.VehicleType}-${item.VehicleCategory?.map((cat) => (cat.Name)).join(', ')



            }`)).join('; '),
          Load_Manager: `${dataObject?.Load_Manager?.FullName || ""}(${dataObject?.Load_Manager?.mobileNumber || ""})`,
          Load_Type: dataObject?.Load_Type || "",

          Loading_Address: dataObject?.Loading_Address_Line_1,
          No_Of_Vehicels_Required: dataObject?.No_Of_Vehicels_Required,
          Target_Price: dataObject?.Target_Price || "",
          Unloading_Address: dataObject?.Unloading_Address_Line_1,
          Payment_Percentage: dataObject?.Payment_Percentage,
          Total_Weight: dataObject?.Total_Weight || "",
          Age: convertToAge(dataObject.Load_Post_Time),
          Material: `${dataObject?.Material_Category}${dataObject?.Exact_Content ? ` - ${dataObject?.Exact_Content}` : ""}`
        }
        setDisplayData(obj)

      }
      else if (TypeofPortal.includes("Load")) {
        let dataObject: any = Object.values(Data)[0]
        console.log(dataObject)
        let obj = {

          Business_Name: dataObject?.Account_ID?.Business_Name,
          Vehicle_No: dataObject?.Vehicle_No,
          Loading_Search_Radius: dataObject?.Loading_Search_Radius,
          Contact_No: dataObject?.Contact_No,
          Vehicle_Type: dataObject?.Vehicle_Type || "",

          Unloading_Search_Radius: dataObject?.Unloading_Search_Radius,
          Post_Duration: dataObject?.Post_Duration,
          Vehicle_Category: dataObject?.Vehicle_Category || "",
          Loading_Address: dataObject?.Loading_Address_Line_1,
          Note: dataObject?.Notes || "",
          Age: convertToAge(dataObject.Truck_Repost_Time),
          Unloading_Points: dataObject?.Unloading_Points?.map((el) =>
            el.Unloading_Name
          ).join(', '),

        }
        setDisplayData(obj);
      }
    }
  }, [Data])
  function Submit(Id) {
    CloseEntry({
      variables: {
        id: Id,
        userInput: {
          Is_Live: false,
          Is_Archive: true,
        },
      },
    })
      .then((res) => {
        SuccessToast("Truck Closed");
        refetch()
        setConfirmModal(false)

      })
      .catch((err) => ErrorToast(err.message));
  }

  const config = useMemo(
    () => ({
      dataKey: dataKey,
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["is_Audit", "__typename"],
      AddCol: [{
        colName: "Close", value: (obj) => {
          return <a
            href="#"
            style={{ color: "blue", textDecoration: "none" }}
            onClick={() => {
              setConfirmModal(true)
              setEditId(obj._id)
            }}
          >
            Close
          </a>

        }
      }],
      calculateAge: TypeofPortal == "Matching Loads" ? "createdAt" : "Truck_Repost_Time"
    }),
    []
  );



  const { loading: processDataLoading } = useProcessData(data, setFormData, config, error);

  return (
    <>
      <Reactportal open={show} onClose={setShowModal} TypeOfPortal={TypeofPortal}>
        <div className="MatchingContainer">
          <RenderData data={DisplayData} />
          {/* <Button name="modalbutton" text="Close" action={() => { Edit(Id) }} /> */}
          {processDataLoading || loading ? (
            <Loading />
          ) : !formData?.length ? (
            <p className="DataNotAvailable">Data not Available</p>
          ) : (
            <div className="MatchingModalContainer">

              <LoadTable title={TypeofPortal == "Matching Loads" ? "Loads" : "Truck_Post"}
                dragDrop={true} TypeOfPortal="View" data={formData} loading={processDataLoading} error={error} />
            </div>
          )}
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={""}
          submitType={""}
          SaveAndClose={""}
          handleformclose={() => {
            setShowModal(false);
          }}
          handleFileDelete={() => { }}
          TypeOfPortal={""}
        />
      </Reactportal>
      {
        confirmModal &&
        <Confirm
          settoggle={setConfirmModal}
          loadingState={EditLoading}
          toggle={confirmModal}
          submitType="Yes"
          submit={() => Submit(editId)}
          message={"Are You Sure You want to Close This Truck"}
        />
      }
    </>
  );
};
